module.exports = __webpack_public_path__ + "static/media/Gafas de sol.556f1e34.svg";